export default "__VITE_ASSET__d99d0c06__"